/*******************************************************************************
 NAME     : pageLoaderUtil
 PURPOSE  : 메뉴가 가리키는 화면 모듈을 import.meta.glob 맵에서 안전하게 찾는다.

 메뉴는 DB(E3_PGM.PGM_PATH / E3_MENU)에서 오고 화면 파일은 빌드에서 온다. 둘이
 어긋나면 - 예: SYS430(워크플로우 엔진 관리)은 메뉴가 use_yn='Y' 인데 SYS430.jsx 는
 main 에 없다 - glob 맵에 키가 없다. 없는 키를 그대로 호출하면 번들에서
 "t[n] is not a function" 이 터지고 ErrorBoundary 가 화면 전체를 덮어, 사용자는
 어떤 메뉴가 문제인지도 알 수 없다. 여기서 미리 갈라 두어 호출부가 안내 화면을
 대신 띄울 수 있게 한다.

 REVISIONS:
 Ver.       Date        Author           Description
 ---------  ----------  ---------------  ------------------------------------
 1.0        2026-09-10  HieuNT161        1. 최초 작성
 *******************************************************************************/

/** 메뉴 경로(/System/SYS430)를 glob 맵의 키(/src/pages/System/SYS430.jsx)로 바꾼다. */
export const pageModuleKey = (programPath) =>
  `/src/pages/${String(programPath ?? "")
    .replace(/\/+/g, "/")
    .replace(/^\//, "")}.jsx`;

/**
 * @param {Record<string, () => Promise<unknown>>} modules import.meta.glob 결과
 * @param {string} programPath 메뉴가 들고 있는 화면 경로
 * @returns {{key: string, loader: (() => Promise<unknown>) | null}} 없으면 loader 는 null
 */
export const resolvePageLoader = (modules, programPath) => {
  const key = pageModuleKey(programPath);
  const loader = modules?.[key];
  return { key, loader: typeof loader === "function" ? loader : null };
};
